import React from 'react';
import {Modal} from '@ui/overlays/modal';
import {IconButton} from '@ui/buttons/icon-button';
import {CloseIcon} from '@ui/icons/material/Close';
import {Trans} from '@ui/i18n/trans';
import {UserThemeSelector} from '@ui/themes/user-theme-selector';
import {UserThemeInfo} from '@ui/themes/user-themes';

interface UserThemeDialogProps {
  isOpen: boolean;
  onClose: () => void;
  themes: UserThemeInfo[];
  selectedThemeId: number | null;
  isLoading?: boolean;
  isApplying?: boolean;
  onSelect: (themeId: number | null) => void;
}

export function UserThemeDialog({
  isOpen,
  onClose,
  themes,
  selectedThemeId,
  isLoading,
  isApplying,
  onSelect,
}: UserThemeDialogProps) {
  if (!isOpen) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="mx-20 flex max-h-[85vh] w-[calc(100%-40px)] max-w-5xl flex-col overflow-hidden rounded-lg border bg-paper shadow-2xl pointer-events-auto">
        <div className="flex items-start justify-between gap-16 border-b px-24 py-18">
          <div className="min-w-0">
            <div className="text-base font-semibold text-main">
              <Trans message="Seu Tema" />
            </div>
            <p className="mt-6 text-sm text-muted">
              <Trans message="Choose one of the themes available for your plan and apply it immediately." />
            </p>
          </div>

          <IconButton
            aria-label="Close theme dialog"
            size="sm"
            className="text-muted"
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </div>

        <div className="flex-auto overflow-y-auto px-24 py-20">
          <UserThemeSelector
            themes={themes}
            selectedThemeId={selectedThemeId}
            isLoading={isLoading}
            isApplying={isApplying}
            onSelect={onSelect}
          />
        </div>
      </div>
    </Modal>
  );
}
